interface SaveDeviceAndPassData {
  type?: any
  manufacturer?: any
  model?: any
  carrier?: any
  site?: any
  center?: any
  production_date?: string
  warranty_expiration_date?: string
  serviceStatus?: any
}

interface Action {
  type: string
  payload: SaveDeviceAndPassData | null
}

const saveDeviceAndPassData = (state: SaveDeviceAndPassData | null = null, action: Action) => {
  switch (action.type) {
    case 'SET_SAVE_DEVICE_AND_PASS_DATA':
      return action.payload
    default:
      return state
  }
}

export default saveDeviceAndPassData
